import React, { useEffect } from "react";
import "../Stylesheets/Curriculum.css";
import AOS from "aos";
import "@fortawesome/fontawesome-free/css/all.min.css";

export default function Curriculum() {
  useEffect(() => {
    AOS.init({
      duration: 1500,
      once: true,
    });
    window.scrollTo({ behavior: "smooth", top: 0 });
  }, []);
  // const technologies = [
  //   {
  //     icon: "fab fa-html5",
  //     name: "HTML5",
  //     description: "Modern markup language",
  //   },
  //   {
  //     icon: "fab fa-css3-alt",
  //     name: "CSS3",
  //     description: "Advanced styling & animations",
  //   },
  //   {
  //     icon: "fab fa-react",
  //     name: "React",
  //     description: "Modern frontend framework",
  //   },
  //   {
  //     icon: "fab fa-angular",
  //     name: "Angular",
  //     description: "Enterprise frontend solution",
  //   },
  //   { icon: "fab fa-php", name: "PHP", description: "Server-side scripting" },
  //   {
  //     icon: "fa-brands fa-laravel",
  //     name: "Laravel",
  //     description: "PHP web framework for modern applications",
  //   },
  //   {
  //     icon: "fab fa-node-js",
  //     name: "Node.js",
  //     description: "JavaScript runtime",
  //   },
  //   {
  //     icon: "fas fa-server",
  //     name: "Express.js",
  //     description: "Web framework for Node.js",
  //   },
  //   { icon: "fas fa-leaf", name: "MongoDB", description: "NoSQL database" },
  //   {
  //     icon: "fab fa-bootstrap",
  //     name: "Bootstrap",
  //     description: "CSS framework",
  //   },
  //   {
  //     icon: "fas fa-database",
  //     name: "SQL",
  //     description: "Database management",
  //   },
  //   {
  //     icon: "fa-solid fa-republican",
  //     name: "PostgreSQL",
  //     description: "Advanced SQL database",
  //   },
  //   {
  //     icon: "fab fa-python",
  //     name: "Python",
  //     description: "High-level programming language",
  //   },
  //   {
  //     icon: "fas fa-cloud",
  //     name: "DevOps",
  //     description: "Deployment & automation",
  //   },
  //   {
  //     icon: "fab fa-apple",
  //     name: "iOS",
  //     description: "Apple mobile operating system",
  //   },
  //   {
  //     icon: "fab fa-android",
  //     name: "Android",
  //     description: "Google mobile operating system",
  //   },
  //   {
  //     icon: "fa-brands fa-java",
  //     name: "Java",
  //     description: "Enterprise programming language",
  //   },
  //   {
  //     icon: "fab fa-android",
  //     name: "Kotlin",
  //     description: "Modern Android programming language",
  //   },
  //   {
  //     icon: "fa-brands fa-swift",
  //     name: "Swift",
  //     description: "Apple programming language",
  //   },
  //   {
  //     icon: "fas fa-cloud",
  //     name: "Azure",
  //     description: "Microsoft cloud platform",
  //   },
  // ];

  // const frontendSkills = [
  //   "HTML5 & Semantic Web",
  //   "Advanced CSS3 & Flexbox/Grid",
  //   "React.js & Redux",
  //   "Angular Framework",
  //   "Bootstrap & Responsive Design",
  // ];

  // const backendSkills = [
  //   "PHP & Server-side Programming",
  //   "Node.js & Express.js",
  //   "MongoDB & Database Design",
  //   "SQL & PostgreSQL",
  //   "DevOps & Cloud Deployment",
  // ];

  const technologies = [
    {
      icon: "https://d242nlqul83u9g.cloudfront.net/adminpanel/carrermate/img97719_IMG.png",
      name: "HTML5",
      description: "Modern markup language",
    },
    {
      icon: "https://d242nlqul83u9g.cloudfront.net/adminpanel/carrermate/img23588_IMG.png",
      name: "CSS3",
      description: "Advanced styling & animations",
    },
    {
      icon: "https://d242nlqul83u9g.cloudfront.net/adminpanel/carrermate/img35611_IMG.png",
      name: "React",
      description: "Modern frontend framework",
    },
    {
      icon: "https://d242nlqul83u9g.cloudfront.net/adminpanel/carrermate/img86621_IMG.png",
      name: "Angular",
      description: "Enterprise frontend solution",
    },
    //,-js
    // icon: "https://d242nlqul83u9g.cloudfront.net/adminpanel/carrermate/img38874_IMG.png",

    {
      icon: "https://d242nlqul83u9g.cloudfront.net/adminpanel/carrermate/img48096_IMG.png",
      name: "PHP",
      description: "Server-side scripting",
    },
    {
      icon: "https://d242nlqul83u9g.cloudfront.net/adminpanel/carrermate/img76622_IMG.png",
      name: "Laravel",
      description: "PHP web framework",
    },
    {
      icon: "https://d242nlqul83u9g.cloudfront.net/adminpanel/carrermate/img63693_IMG.png",
      name: "Node.js",
      description: "JavaScript runtime",
    },
    {
      icon: "https://d242nlqul83u9g.cloudfront.net/adminpanel/carrermate/img74436_IMG.png",
      name: "Express.js",
      description: "Web framework for Node.js",
    },
    {
      icon: "https://d242nlqul83u9g.cloudfront.net/adminpanel/carrermate/img31049_IMG.png",
      name: "MongoDB",
      description: "NoSQL database",
    },
    {
      icon: "https://d242nlqul83u9g.cloudfront.net/adminpanel/carrermate/techbridge97514_IMG.png",
      name: "Bootstrap",
      description: "Responsive CSS framework",
    },
    {
      icon: "https://d242nlqul83u9g.cloudfront.net/adminpanel/carrermate/img66537_IMG.png",
      name: "SQL",
      description: "Database management",
    },
    {
      icon: "https://d242nlqul83u9g.cloudfront.net/adminpanel/carrermate/img19120_IMG.png",
      name: "PostgreSQL",
      description: "Advanced relational database",
    },
    {
      icon: "https://d242nlqul83u9g.cloudfront.net/adminpanel/carrermate/img76040_IMG.png",
      name: "Python",
      description: "High-level programming language",
    },
    {
      icon: "https://d242nlqul83u9g.cloudfront.net/adminpanel/carrermate/techbridge93152_IMG.png",
      name: "DevOps",
      description: "Deployment & automation",
    },
    {
      icon: "https://d242nlqul83u9g.cloudfront.net/adminpanel/carrermate/techbridge39832_IMG.png",
      name: "iOS",
      description: "Apple mobile platform",
    },
    {
      icon: "https://d242nlqul83u9g.cloudfront.net/adminpanel/carrermate/img91845_IMG.png",
      name: "Android",
      description: "Google mobile platform",
    },

  ];
  return (
    <section
      id="curriculum"
      className="py-5 bg-dark text-light position-relative min-vh-100 d-flex align-items-center"
    >
      {/* Background video */}
      {/* <div className=" video-wrapper program-bg  ">
        <video loop autoPlay muted playsInline>
          <source src="https://cdn.pixabay.com/video/2024/06/06/215500_large.mp4" />
        </video>
        <div className="video-overlay"></div>
      </div> */}

      <div className="container position-relative">
        {/* Section Title */}
        <div className="row mb-5">
          <div className="col-lg-8 mx-auto text-center">
            <h1 className="fw-bold" style={{ color: "rgb(108, 174, 225)" }}>
              Complete Technology Stack
            </h1>
            <p
              className="text-light mt-5 fs-5"
              style={{ color: "rgba(237, 240, 241, 1)" }}
            >
              Master the most in-demand technologies used by top tech companies
              worldwide.
            </p>
          </div>
        </div>

        {/* Technologies Grid */}
        <div className="row g-4 text-center ">
          {technologies.map((tech, index) => (
            <div
              key={index}
              className="col-6 col-md-4 col-lg-3 "
              data-aos="fade-down"
            >
              <div className="p-4 rounded h-100 shadow-sm tech-item   ">
                <img
                  src={tech.icon}
                  alt={tech.name}
                  style={{
                    width: "60px",
                    height: "60px",
                    objectFit: "contain",
                    marginBottom: "15px",
                  }}
                />
                <h6 className="fw-semibold">{tech.name}</h6>
                <p
                  className="small  mb-0"
                  style={{ color: "rgba(198, 200, 201, 1)" }}
                >
                  {tech.description}
                </p>
              </div>
            </div>
          ))}
        </div>

        {/* Learning Modules */}
        {/* <div className="row mt-5 d-flex justify-content-center">
          <div className="col-lg-10 tech-stack-grid card-custom1 ">
            <div className="p-5" data-aos="fade-up">
              <h3 className=" mb-4" style={{ color: "rgb(108, 174, 225)" }}>
                Learning Modules Breakdown
              </h3>
              <div className="row">
                Frontend
                <div className="col-md-6 mb-4 mb-md-0 ">
                  <h5 className="mb-3">Frontend Development</h5>
                  <ul className="list-unstyled text-secondary">
                    {frontendSkills.map((skill, index) => (
                      <li
                        key={index}
                        className="mb-2"
                        style={{ color: "rgba(198, 200, 201, 1)" }}
                      >
                        <i className="fas fa-code text-success me-2"></i>
                        {skill}
                      </li>
                    ))}
                  </ul>
                </div>
                Backend
                <div className="col-md-6">
                  <h5 className="mb-3">Backend Development</h5>
                  <ul className="list-unstyled text-secondary">
                    {backendSkills.map((skill, index) => (
                      <li
                        key={index}
                        className="mb-2"
                        style={{ color: "rgba(198, 200, 201, 1)" }}
                      >
                        <i className="fas fa-server text-warning me-2"></i>
                        {skill}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div> */}
      </div>
    </section>
  );
}
